import { makeObservable, action } from 'mobx';
import StoreBase from './Base';
import { enableStaticRendering } from 'mobx-react';
import { httpRequest } from '@/request';
import { SERVER } from '@/request/config';
import { CapturePaypalOrderResponse, CreateSPBOrderResponse } from './types/payment';
import { redirectToOrderResultPage } from '@/utils/mobxUtils/order';
import { MobxStore } from './types';
import { encryptBE } from '@/utils/libs/JSEncrypt';

enableStaticRendering(typeof window === 'undefined');

class PaymentStore extends StoreBase<'paymentStore'> {
  constructor(props: MobxStore) {
    super(props);
    makeObservable(this);
  }

  /** SPB流程创建paypal order */
  @action
  createSPBOrder = (orderNumber: string) => {
    const { order } = this.root!;
    order.setStateValue('_beingPaid', true);
    const payMode = order.hasCloudServiceProduct ? 2 : 1;

    return httpRequest<CreateSPBOrderResponse>({
      url: SERVER.API_SERVER_PAYMENT + '/paypal/spbPay',
      method: 'post',
      data: { orderNumber, payMode },
    })
      .then((res) => {
        if (res?.code === 0 && res.data) {
          //如果有orderID则唤起支付弹窗，失败场景后端直接304跳转支付结果页，前端无需考虑失败场景
          const { orderToken } = res.data;
          if (orderToken) return orderToken;
        }
        redirectToOrderResultPage(orderNumber);
        order.setStateValue('_beingPaid', false);
        return null;
      })
      .catch(() => {
        redirectToOrderResultPage(orderNumber);
      });
  };

  /** SPB流程，支付弹窗中用户确认支付授权后，调用接口通知后端capture订单收款 */
  @action
  capturePaypalOrder = (paypalOrderId: string, orderNumber: string) => {
    const { order } = this.root!;
    order.setStateValue('_beingPaid', true);

    return httpRequest<CapturePaypalOrderResponse>({
      url: SERVER.API_SERVER_PAYMENT + '/paypal/notify/spbPay',
      method: 'post',
      data: { instaCallback: encryptBE(orderNumber), token: paypalOrderId },
    })
      .then((res) => {
        // 有四种情况：1. 支付成功。 2. capture失败返回paypal的res 3. capture失败不返回paypal的res 4. 其他异常（被catch）
        // 响应正常的情况全部在SDK回调中处理 => PaypalSmartButton.tsx
        if (res?.code === 0) {
          return res.data;
        }
        return redirectToOrderResultPage(orderNumber);
      })
      .catch(() => {
        return redirectToOrderResultPage(orderNumber);
      });
  };
}

export default PaymentStore;
